import React, { Component } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import {Card, IconButton, Divider, Typography,Grid, CardContent, Box} from '@material-ui/core'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import PersonIcon from '@material-ui/icons/Person';
import {writelog,handleError,getApiDomain} from './../../utils'
import bakimg from '../../images/background.png'


const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      backgroundColor: '#FFFFFF',//theme.palette.background.paper,
      display: 'flex',
      height: 640,
      textAlign:"center",
      paddingTop:2,
      justifyContent: "center",
      alignItems:"center"
    }
  }));


export default function Sigin(props) {
    const classes = useStyles();

    const [QRImage,setQRImage] = React.useState("") //base64 image 
    const [QRCode,setQRCode] = React.useState("")
    const [UserID,setUserID] = React.useState("")


    async function queryQRLoginStatus(qrcode){
        var reqData = {
            Cmd: 1,
            Code: qrcode,
            UID: ""
        }
        let response = await fetch(getApiDomain()+'/users/QRLogin?rnd='+Math.random()*999,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(reqData)
        }).catch(handleError);
        if(response.ok){
            let resData = await response.json();
            if(resData.Result ===0) {
                return resData
            } else {
                //should not write log
                //writelog("queryQRLoginStatus2","resData fail",resData)
                //console.log("queryQRLoginStatus res fail",resData)
            }
        } else {
            writelog("queryQRLoginStatus1","response fail",response)
            //console.log("queryQRLoginStatus res fail",response)
        }
        return {
            Result:1,
            Message:""
        }
      }
  
      var intervalID = undefined
      var num = 0 
      async function checkStatus(qrcode){
          num++
          var res = await queryQRLoginStatus(qrcode)
          if(res.Result == 0){
              clearTimeout(intervalID)
              await props.fetchUsrInfo(res.UID,res.SessionID)
              window.location.href="#/"
              //console.log("go to #/")
              return 
          }
          if(num>60){
              clearTimeout(intervalID)
              window.location.href="#/"
              return 
          }
        clearTimeout(intervalID)  
        intervalID = setTimeout(checkStatus,1500,qrcode)
    }

   async function getQRRes(){
    var reqData = {
        Cmd:0,
        Code: Math.ceil(Math.random()*999).toString(),
        UID:""
    }
    let response = await fetch(getApiDomain()+'/users/QRLogin?rnd='+Math.random()*999,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify(reqData)
    }).catch(handleError);
    if(response.ok){
        let resData = await response.json();
        if(resData.Result ===0) {
            //setQRCode(resData.QRCode)
            //setUserID(resData.UID)
            setQRImage(resData.QRImage)
            intervalID = setTimeout(checkStatus,1500,resData.QRCode)
        } else {
            writelog("onlinepay getQRRes","resData fail",resData)
        }
    } else {
        writelog("onlinepay getQRRes","response fail",response)
    }
  }    

   if(QRImage == ""){
        clearTimeout(intervalID)
        getQRRes()
   }
   
    return (
        <div className={classes.root} style={{backgroundImage:`url(${bakimg})`}}>
            <Card  variant='outlined' style={{width:200,padding:16}}>
                <Grid justify="space-between" container space={24}>
                    <Grid item>
                        <IconButton style={{display:"none"}} size="small" onClick={()=>{clearTimeout(intervalID);num=100;window.location.href="#/"}} >
                            <KeyboardBackspaceIcon style={{width:16,height:16}} ></KeyboardBackspaceIcon>
                        </IconButton>
                    </Grid>
                    <Grid item >
                        <Box style={{display:"flex",verticalAlign:"middle"}}>
                            <PersonIcon style={{width:16,height:16,paddingRight:2,verticalAlign:"bottom"}} ></PersonIcon>
                            <Typography variant="body2" style={{paddingRight:16}} >登录</Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Divider style={{marginTop:4}} light />
                <CardContent style={{ustifyContent: "center",border: '1px solid gainsboro',margin:16,marginTop:16,padding:8}} light>
                    <img style={{width:136,height:136}} src={QRImage} alt="加载中..."></img>
                </CardContent>
                <CardContent style={{padding:8,margin:0,textAlign:"center"}}>
                    <Typography variant="body1" color="primary" style={{fontWeight:"bold"}} >{"微信扫码"}</Typography>
                </CardContent>
            </Card> 
        </div>
    )
}
